module.exports = ".modal{\n    width: 40%;\n}\n#heading{\n    font-size: 1.3rem;\n}"